import axios from "axios";

//const
const EQUIPMENT_ADD_UPDATE_DATA = "equipmentAdd/EQUIPMENT_ADD_UPDATE_DATA";
const EQUIPMENT_ADD_STORE_EQUIPMENT_CERTIFIES = "equipmentAdd/EQUIPMENT_ADD_STORE_EQUIPMENT_CERTIFIES";
const EQUIPMENT_ADD_STORE_EQUIPMENT_TYPES = "equipmentAdd/EQUIPMENT_ADD_STORE_EQUIPMENT_TYPES";
const EQUIPMENT_ADD_STORE_EQUIPMENT_STATUSES = "equipmentAdd/EQUIPMENT_ADD_STORE_EQUIPMENT_STATUSES";
const EQUIPMENT_ADD_TOGGLE_LOADING = "equipmentAdd/EQUIPMENT_ADD_TOGGLE_LOADING";

//reducer
export const equipmentAdd = (state = {
  loading: false,

  equipmentCertifies: [],
  equipmentTypes: [],
  equipmentStatuses: [],
  collectNodeTags: [],

  importTags: [],
  rowKey: 1,
}, action) => {
  switch (action.type) {
    case EQUIPMENT_ADD_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case EQUIPMENT_ADD_STORE_EQUIPMENT_CERTIFIES:
      return {
        ...state,
        equipmentCertifies: action.data,
        collectNodeTags: [],
        importTags: [],
        rowKey: 1,
      };
    case EQUIPMENT_ADD_STORE_EQUIPMENT_TYPES:
      return {
        ...state,
        equipmentTypes: action.data,
        collectNodeTags: [],
        importTags: [],
        rowKey: 1,
      };
    case EQUIPMENT_ADD_STORE_EQUIPMENT_STATUSES:
      return {
        ...state,
        equipmentStatuses: action.data,
        collectNodeTags: [],
        importTags: [],
        rowKey: 1,
      };
    case EQUIPMENT_ADD_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    default:
      return state
  }
};

/**
 * update data based
 */
export const updateEquipmentData = (data) => {
  return {
    type: EQUIPMENT_ADD_UPDATE_DATA,
    data: data
  }
};

/**
 * get equipment certifies
 */
export const getEquipmentCertifies = (enterpriseId) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get(`/api-equipment/getEquipmentCertifyListByEnterpriseId/${enterpriseId}`, {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeEquipmentCertifies(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store all equipment certifies
 */
export const storeEquipmentCertifies = (equipmentCertifies) => {
  return {
    type: EQUIPMENT_ADD_STORE_EQUIPMENT_CERTIFIES,
    data: equipmentCertifies
  }
};

/**
 * get equipment types
 */
export const getEquipmentTypes = () => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get(`/api-equipment/getEquipmentTypeList`, {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeEquipmentType(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store all equipment types
 */
export const storeEquipmentType = (equipmentTypes) => {
  return {
    type: EQUIPMENT_ADD_STORE_EQUIPMENT_TYPES,
    data: equipmentTypes
  }
};

/**
 * get equipment statuses
 */
export const getEquipmentStatuses = () => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get(`/api-equipment/getEquipmentStatuses`, {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeEquipmentStatuses(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store all equipment statuses
 */
export const storeEquipmentStatuses = (equipmentStatuses) => {
  return {
    type: EQUIPMENT_ADD_STORE_EQUIPMENT_STATUSES,
    data: equipmentStatuses
  }
};

/**
 * toggle loading
 */
export const toggleLoading = (show) => {
  return {
    type: EQUIPMENT_ADD_TOGGLE_LOADING,
    data: show
  }
};

